import React from 'react'
import { useTranslation } from 'react-i18next'
import { FOOD_KIND } from '../../../constants'
import useMoney from '../../../hooks/useMoney'
import { getFoodPriceShow } from '../../../utils'
import { getFullFileUrl } from '../../../utils/formatData'
import FormatCurrency from '../../elements/FormatCurrency'

import disableMask from '../../../assets/images/disable-mask.png';
import { clsx } from '../../../utils/helper'

const FoodItemDesk = ({ food, handleClickAdd, setMoreInfo, isFoodSoldOut }) => {
    const { currentPrice, originPrice } = useMoney(getFoodPriceShow, food)

    const { t } = useTranslation()

    const handleViewMoreInfo = e => {
        e.stopPropagation()
        e.preventDefault()

        setMoreInfo(food.productInfo)
    }

    return (
        <div onClick={handleClickAdd} className={clsx('food-info', isFoodSoldOut && 'food-desk-soldout')}>
            <div className="food-info__general">
                <div className="name">
                    {food.name}
                    {food.productInfo && (
                        <span
                            onClick={handleViewMoreInfo}
                            className="label-3 ml-2 primary-color"
                        >
                            {t('button.moreInfo')}
                        </span>
                    )}
                </div>
                <div className="description label-2">{food.description}</div>
                <div className="price">
                    {food.kind !== FOOD_KIND.FOOD_SUBS && (
                        <div className="current">
                            <FormatCurrency
                                className="current"
                                amount={currentPrice}
                            />
                           {!!originPrice && (
                               <FormatCurrency
                                className="origin ml-2"
                                amount={originPrice}
                            />
                           )}
                        </div>
                    )}
                </div>
            </div>
            <div className={clsx('food-info__image', food.imagePath && 'has-image')}>
                {food.imagePath && <img className="image" alt="list food" src={getFullFileUrl(food.imagePath)} />}
                <img alt="disable-mask" className="disable-mask" src={disableMask} />
            </div>
        </div>
    )
}

export default FoodItemDesk
